if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));

        this.stickyAddCart = document.querySelector(".sticky-add-to-cart");
        this.productInfo = document.querySelector(".product");

        this.klaviyoProductInfos();

        if (!this.productInfo) {
          console.error("Elements not found: product");
          return;
        }

        this.currentScrollTop = 0;
        this.onScrollHandler = this.onScroll.bind(this);
        this._scrollRaf = null;

        window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      klaviyoProductInfos(selectedVariant) {
        if (document.body.getAttribute('_pagetype') !== 'product') return;
        if (this._klaviyoViewedTimer) clearTimeout(this._klaviyoViewedTimer);

        const track = () => {
          if (!(window.Pandectes && window.Pandectes.consent && window.Pandectes.consent.performance === true)) {
            this._klaviyoViewedTimer = setTimeout(track, 1000);
            return;
          }
          if (typeof window.klaviyo === 'undefined' || typeof klaviyo.track !== 'function') {
            this._klaviyoViewedTimer = setTimeout(track, 1000);
            return;
          }

          let parsedSelectedVariant = null;
          try {
            parsedSelectedVariant = selectedVariant ? JSON.parse(selectedVariant) : null;
          } catch (e) {
            parsedSelectedVariant = null;
          }

          const data = {
            Name: productInfo?.title,
            $name: parsedSelectedVariant ? parsedSelectedVariant?.name : variantInfo?.name,
            ProductID: parsedSelectedVariant ? parsedSelectedVariant?.sku : variantInfo?.sku,
            ShopifyProductID: productInfo?.id,
            ShopifyVariantID: parsedSelectedVariant ? parsedSelectedVariant?.id : variantInfo?.id,
            ImageURL: productInfo?.images[0],
            UPC: parsedSelectedVariant ? parsedSelectedVariant?.barcode : variantInfo?.barcode,
            Brand: productInfo?.vendor,
            Price: ((parsedSelectedVariant ? parsedSelectedVariant?.price : variantInfo?.price) / 100).toString(),
            $value: (parsedSelectedVariant ? parsedSelectedVariant?.price : variantInfo?.price) / 100,
            CompareAtPrice: ((parsedSelectedVariant ? parsedSelectedVariant?.compare_at_price : variantInfo?.compare_at_price) / 100).toString(),
            Host: window.location.host,
            Href: window.location.href,
          };

          klaviyo.track('Viewed Product', data);

          const trackViewedData = {
            Title: productInfo?.title,
            ItemId: parsedSelectedVariant ? parsedSelectedVariant?.sku : variantInfo?.sku,
            Categories: typeof collectionsInfo !== 'undefined' && collectionsInfo && collectionsInfo[0]?.title,
            ImageUrl: productInfo?.images[0],
            Url: window.location.href,
            Metadata: {
              Brand: productInfo?.vendor,
              Price: ((parsedSelectedVariant ? parsedSelectedVariant?.price : variantInfo?.price) / 100).toString(),
              CompareAtPrice: ((
                parsedSelectedVariant ? parsedSelectedVariant?.compare_at_price : variantInfo?.compare_at_price
              ) / 100).toString(),
            },
          };

          if (typeof klaviyo.trackViewedItem === 'function') {
            klaviyo.trackViewedItem(trackViewedData);
          }
        };

        this._klaviyoViewedTimer = setTimeout(track, 2500);
      }


      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
        window.removeEventListener('scroll', this.onScrollHandler);
        if (this._scrollRaf) cancelAnimationFrame(this._scrollRaf);
        if (this._klaviyoViewedTimer) clearTimeout(this._klaviyoViewedTimer);
        this.collapsibleAbortController?.abort();
      }

      onScroll() {
        if (this._scrollRaf) return;
        this._scrollRaf = requestAnimationFrame(() => {
          this._scrollRaf = null;
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const productBounds = this.productInfo.getBoundingClientRect();

          if (scrollTop > this.currentScrollTop && productBounds.bottom <= 200) {
            this.stickyAddCart?.classList.add('scrolled-past-product');
          } else if (scrollTop <= this.currentScrollTop && productBounds.bottom > 200) {
            this.stickyAddCart?.classList.remove('scrolled-past-product');
          }

          this.currentScrollTop = scrollTop;
        });
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });

        /* Collapsible content is below the fold — update after the critical variant paint. */
        this.scheduleCollapsibleUpdate(productUrl, selectedOptionValues);
      }

      scheduleCollapsibleUpdate(productUrl, selectedOptionValues) {
        const container = document.querySelector('#variant-section');
        if (!container) return;

        this.collapsibleAbortController?.abort();
        this.collapsibleAbortController = new AbortController();
        const { signal } = this.collapsibleAbortController;
        const url = this.buildRequestUrlWithParams(productUrl, selectedOptionValues, true);

        const run = () => {
          fetch(url, { signal })
            .then((res) => res.text())
            .then((html) => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const newContent = doc.querySelector('[data-section-id="product-collapsible-section"]');
              if (newContent && container.isConnected) {
                container.innerHTML = newContent.innerHTML;
              }
            })
            .catch((error) => {
              if (error.name !== 'AbortError') console.error(error);
            });
        };

        if ('requestIdleCallback' in window) {
          requestIdleCallback(run, { timeout: 2000 });
        } else {
          setTimeout(run, 200);
        }
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;

        this.klaviyoProductInfos(selectedVariant);

        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);
          this.updateVariantDescription(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = document.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('description');
          updateSourceFromDestination('StickyPrice');
          updateSourceFromDestination('StickyMedia');
          updateSourceFromDestination('StickyAddCart');
          updateSourceFromDestination('StickySku');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('mobile-sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Features');

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          const submitButton = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
          this.productForm?.toggleSubmitButton(
            submitButton?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }
      updateVariantDescription(variantId){
        const variantMetafieldsEl = document.getElementById('VariantDescriptionMetafields');
        let variantMetafields = {};

        if (variantMetafieldsEl) {
          try {
            const fixedJson = variantMetafieldsEl.textContent.replace(/([^\\])""/g, '$1\\"');

            variantMetafields = JSON.parse(fixedJson);
          } catch (e) {
            console.error("Failed to parse variantMetafields JSON:", e);
          }
        }

        const descriptionText = variantMetafields[variantId]?.variant_text || '';
        const variantRomanceDisplay = document.getElementById('CollapsibleAccordion-romance-copy');
        if (variantRomanceDisplay) {
          variantRomanceDisplay.textContent = descriptionText;
        }
      }
      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });

        document.querySelectorAll('.product-form-error-message-wrapper').forEach(error => {
          error.setAttribute('hidden', 'hidden');
          error.querySelector('.product-form-error-message').textContent = '';
        })
      }

      updateURL(url, variantId) {
        const shareUrl = `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`;

        document.querySelectorAll('share-button').forEach((shareButton) => {
          if (typeof shareButton.updateUrl === 'function') {
            shareButton.updateUrl(shareUrl);
          }
        });

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'StickyPrice', 'StickyMedia', 'StickyAddCart', 'StickyPrice', 'Inventory', 'Sku', 'mobile-sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules', 'MediaGallery']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!html) return;

        const getKey = (item) =>
          item?.dataset?.mediaId || item?.dataset?.mediaPosition;

        const updateMediaList = (sourceContainer, destinationContainer) => {
          if (!sourceContainer || !destinationContainer) return;

          const refreshData = () => {
            const sourceItems = Array.from(sourceContainer.querySelectorAll('li'));

            const sourceMap = new Map(
              sourceItems.map((item, index) => [getKey(item), { item, index }])
            );
            const sourceSet = new Set(sourceMap.keys());
            return [sourceItems, sourceSet, sourceMap];
          };

          let [sourceItems, sourceSet, sourceMap] = refreshData();

          const destinationItems = Array.from(destinationContainer.querySelectorAll('li'));
          const destinationKeys = destinationItems.map(getKey);
          const destinationSet = new Set(destinationKeys);
          let shouldRefresh = false;

          // Add new items
          for (let i = destinationItems.length - 1; i >= 0; i--) {
            const key = getKey(destinationItems[i]);
            if (!sourceSet.has(key)) {
              sourceContainer.prepend(destinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < sourceItems.length; i++) {
            const key = getKey(sourceItems[i]);
            if (!destinationSet.has(key)) {
              sourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          if (shouldRefresh) [sourceItems, sourceSet, sourceMap] = refreshData();

          // Sort to match destination order
          destinationItems.forEach((destinationItem, destinationIndex) => {
            const key = getKey(destinationItem);
            const sourceData = sourceMap.get(key);
            if (sourceData && sourceData.index !== destinationIndex) {
              sourceContainer.insertBefore(
                sourceData.item,
                sourceContainer.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );
              [sourceItems, sourceSet, sourceMap] = refreshData();
            }
          });
        };

        const mediaGallerySource = document.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector('media-gallery ul');

        const thumbnailGallerySource = document.querySelector('.thumbnail-slider ul');
        const thumbnailGalleryDestination = html.querySelector('.thumbnail-slider ul');

        const mediaOpenerGallerySource = document.querySelector('.product-media-modal .product-media-modal-content.modal-content-inner');
        const mediaOpenerGalleryDestination = html.querySelector('.product-media-modal .product-media-modal-content.modal-content-inner');

        updateMediaList(mediaGallerySource, mediaGalleryDestination);

        if (thumbnailGallerySource && thumbnailGalleryDestination) {
          thumbnailGallerySource.innerHTML = thumbnailGalleryDestination.innerHTML;
        }

        if (mediaOpenerGallerySource && mediaOpenerGalleryDestination) {
          mediaOpenerGallerySource.innerHTML = mediaOpenerGalleryDestination.innerHTML;
        }

        const mediaButtonsSource = document.querySelector('.product-media-buttons');
        const mediaButtonsDestination = html.querySelector('.product-media-buttons');

        if (mediaButtonsSource && mediaButtonsDestination) {
          mediaButtonsSource.innerHTML = mediaButtonsDestination.innerHTML;
        }

        const productModel = document.querySelector('product-model');

        if (productModel && typeof productModel.loadContent === 'function') {
          productModel.loadContent();
        }

        // Set featured media as active if available
        if (variantFeaturedMediaId) {
          document.querySelector(`media-gallery`)?.setActiveMedia?.(
            `${this.dataset.section}-${variantFeaturedMediaId}`,
            true
          );
        }

        /* Event delegation once — avoid stacking click listeners on every variant change. */
        const mediaGalleryRoot = document.querySelector('media-gallery');
        if (mediaGalleryRoot && mediaGalleryRoot.dataset.mediaSwitchBound !== 'true') {
          mediaGalleryRoot.dataset.mediaSwitchBound = 'true';
          mediaGalleryRoot.addEventListener('click', (event) => {
            const mediaToSwitch = event.target.closest('[data-target]');
            if (!mediaToSwitch || !mediaGalleryRoot.contains(mediaToSwitch)) return;
            mediaGalleryRoot.setActiveMedia?.(mediaToSwitch.dataset.target, false);
          });
        }

        // Update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) {
          modalContent.innerHTML = newModalContent.innerHTML;
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        return fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}